import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getCheckedStyle = (Control: StyledComponent): SerializedStyles => css`
  ${Control} {
    color: ${Color.White};
    background-color: ${Color.Lavender500};
    border-color: transparent;
  }
`
